import {
  DragHandlerWrapper,
  RowSelectButtonContainer,
} from '@databases/context-menu/styles';
import { ActiveVerticalDragHandlerIcon, VerticalDragHandlerIcon } from '@databases/icons';
import { useDatabaseSelectionPing } from '@databases/ping-registry';
import { type HoverProps } from '@databases/react';
import { IGNORED_TABLE_ELEMENT_CLASS } from '@databases/table-resizer';
import { TABLE_CLASSNAMES } from '@databases/utils/constants';
import React, { type FunctionComponent } from 'react';

type RowDragHandleProps = {
  entryId: string;
  hoverProps?: HoverProps;
};

const RowDragHandle: FunctionComponent<RowDragHandleProps> = ({
  entryId,
  hoverProps,
}) => {
  //for now we leverage the ping registry but we will look into a more ideal solution
  const isActive = useDatabaseSelectionPing((reader) => {
    const focused = reader.getFocusedItem();

    if (focused?.type !== 'entry' || focused.entryId !== entryId) {
      return false;
    }
    //Dont show the handle as active if select all
    return reader.hasEntryBeforeSelection() || reader.hasEntryAfterSelection();
  });

  return (
    <RowSelectButtonContainer
      className={IGNORED_TABLE_ELEMENT_CLASS}
      {...hoverProps}
      data-testid="row-select-button"
      role="button"
    >
      <DragHandlerWrapper
        className={TABLE_CLASSNAMES.SELECT_BUTTON}
        data-interactive
        isActive={isActive}
        isDeletionActive={false}
      >
        <div className={TABLE_CLASSNAMES.ACTIVE_DRAG_HANDLER_ICON}>
          <ActiveVerticalDragHandlerIcon
            label={TABLE_CLASSNAMES.ACTIVE_DRAG_HANDLER_ICON}
          />
        </div>
        <div className={TABLE_CLASSNAMES.DRAG_HANDLER_ICON}>
          <VerticalDragHandlerIcon label={TABLE_CLASSNAMES.DRAG_HANDLER_ICON} />
        </div>
      </DragHandlerWrapper>
    </RowSelectButtonContainer>
  );
};

export default RowDragHandle;
